<template>
    <div>
        <!-- <div class="title">
                规章流程
        </div> -->
        <a-table :columns="columns" :data-source="data" :pagination='false' >
            <template slot="operation" slot-scope="text">
                <a href="#" @click="exportWj(text)">下载</a>
            </template>
        </a-table>
        
    </div>
</template>
<script>
export default {
    data () {
        return {
            columns:[
                {
                    title: '序号',
                    dataIndex: 'xh',
                    key: ''
                },
                {
                    title: '资料名',
                    dataIndex: 'wjm',
                    key: ''
                },
                {
                    title: '操作',
                    dataIndex: 'url',
                    scopedSlots: { customRender: 'operation' }
                },
            ],
            data:[
                {
                    xh:"1",wjm:"经济学院主办学术报告记录表",url:this.$store.state.axiosUrl+'/api-f/statics/template/经济学院主办学术报告记录表.doc'
                },
                {
                    xh:"2",wjm:"上海大学经济学院学术讲座申请表",url:this.$store.state.axiosUrl+'/api-f/statics/template/上海大学经济学院学术讲座申请表.doc'
                },
                {
                    xh:"3",wjm:"经济学院专业教师科研考核表（2024版）",url:this.$store.state.axiosUrl+'/api-f/statics/template/经济学院专业教师科研考核表（2024版）.xlsx'
                }
            ]
        }
    },
    methods:{
        exportWj(url){
            window.open(url)
        },
    }

}
</script>

<style scoped>
    .title{
        font-weight:bold;
        font-size: 1.5rem;
        text-align: center;
        margin-bottom: 1rem;
    }
</style>